var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.67,22H6.33A4.33,4.33,0,0,1,2,17.68V6.32A4.33,4.33,0,0,1,6.33,2H17.67A4.33,4.33,0,0,1,22,6.32V17.68A4.33,4.33,0,0,1,17.67,22ZM6.33,4.08A2.25,2.25,0,0,0,4.08,6.33V17.68a2.25,2.25,0,0,0,2.25,2.24H17.67a2.25,2.25,0,0,0,2.25-2.24V6.32a2.25,2.25,0,0,0-2.25-2.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.21,18.08l-5-5a.28.28,0,0,0-.39,0l-5,5L2.31,16.58l5-5a2.35,2.35,0,0,1,3.33,0l5,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.29,14.21l-1.47-1.47,4.11-4.11a2.08,2.08,0,0,1,2.91-.1l3.86,3.85-1.48,1.48L16.4,10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17,5.33A1.85,1.85,0,1,1,6.32,7.18h0A1.85,1.85,0,0,1,8.17,5.33h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.5b3fbc33c6f02d021baf4fb5531c5bc2.svg";
export { ForwardRef as ReactComponent };